import { c as _c } from "react/compiler-runtime";
import useWindowScrollPosition from 'hooks/useWindowScrollPosition';
import { useEffect } from 'react';
const useThrottledWindowScrollPosition = t0 => {
  const $ = _c(8);
  const {
    callback,
    time,
    isScrollTrackingDisabled: t1,
    previousScrollPosition
  } = t0;
  const isScrollTrackingDisabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isScrollTrackingDisabled || $[1] !== previousScrollPosition || $[2] !== time) {
    t2 = {
      isScrollTrackingDisabled,
      time,
      previousScrollPosition
    };
    $[0] = isScrollTrackingDisabled;
    $[1] = previousScrollPosition;
    $[2] = time;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const throttledScrollPosition = useWindowScrollPosition(t2);
  let t3;
  let t4;
  if ($[4] !== callback || $[5] !== throttledScrollPosition) {
    t3 = () => {
      callback(throttledScrollPosition);
    };
    t4 = [callback, throttledScrollPosition];
    $[4] = callback;
    $[5] = throttledScrollPosition;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
};
export default useThrottledWindowScrollPosition;